import { render, staticRenderFns } from "./FormControlArrayObjects.vue?vue&type=template&id=47be41ba&scoped=true"
import script from "./FormControlArrayObjects.vue?vue&type=script&lang=js"
export * from "./FormControlArrayObjects.vue?vue&type=script&lang=js"
import style0 from "./FormControlArrayObjects.vue?vue&type=style&index=0&id=47be41ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47be41ba",
  null
  
)

export default component.exports